<form [formGroup]="tRDAFormGroup">

  <div class="row">
    <mat-form-field appearance="standard">
      <mat-label>Currículum vitae</mat-label>
      <ngx-mat-file-input formControlName="cv" accept="pdf, .jpg, .zip, .rar, .7z"
                          (change)="onFileChange('cv')" placeholder="Currículum vitae" ></ngx-mat-file-input>
      <mat-icon matSuffix><fa-icon icon="paperclip"></fa-icon></mat-icon>
      <mat-hint align="end">Tamaño máximo 10 MB en formato pdf, .jpg, .zip, .rar o .7z</mat-hint>
      <mat-error>Debe ingresar un archivo con extensión pdf, .jpg, .zip, .rar o .7z, menor a 10 MB</mat-error>
    </mat-form-field>
  </div>

  <div class="row">
    <mat-form-field appearance="standard">

      <mat-label>Carta recomendación</mat-label>
      <ngx-mat-file-input formControlName="carta_recomendacion" accept="pdf, .jpg, .zip, .rar, .7z"
                          (change)="onFileChange('carta_recomendacion')" placeholder="Carta recomendación" ></ngx-mat-file-input>
      <mat-icon matSuffix><fa-icon icon="paperclip"></fa-icon></mat-icon>
      <mat-hint align="end">Tamaño máximo 10 MB en formato pdf, .jpg, .zip, .rar o .7z</mat-hint>
      <mat-error>Debe ingresar un archivo con extensión pdf, .jpg, .zip, .rar o .7z, menor a 10 MB</mat-error>
    </mat-form-field>
  </div>

</form>

